import * as React from 'react';

export function CompanionInstall() {
  return (
    <div className="mx-auto max-w-2xl p-8 space-y-8">
      <div>
        <h1 className="text-2xl font-bold">Brkthru Companion Extension</h1>
        <p className="mt-2 text-muted-foreground">
          Install or update the Chrome extension for DSP context tracking and metrics.
        </p>
      </div>

      <section className="space-y-3">
        <h2 className="text-lg font-semibold">Download</h2>
        <a
          href="/companion/download"
          className="inline-flex items-center gap-2 rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:bg-primary/90">
          Download latest version
        </a>
      </section>

      <section className="space-y-3">
        <h2 className="text-lg font-semibold">Installation</h2>
        <ol className="list-decimal list-inside space-y-2 text-sm">
          <li>Download the zip file using the button above</li>
          <li>Unzip the downloaded file to a folder on your computer</li>
          <li>
            Open Chrome and navigate to{' '}
            <code className="text-xs bg-muted px-1 py-0.5 rounded">chrome://extensions</code>
          </li>
          <li>Enable &quot;Developer mode&quot; using the toggle in the top-right corner</li>
          <li>Click &quot;Load unpacked&quot; and select the unzipped folder</li>
        </ol>
      </section>

      <section className="space-y-3">
        <h2 className="text-lg font-semibold">Updating</h2>
        <ol className="list-decimal list-inside space-y-2 text-sm">
          <li>Download the latest zip file</li>
          <li>Unzip to the same folder (overwrite existing files)</li>
          <li>
            Go to <code className="text-xs bg-muted px-1 py-0.5 rounded">chrome://extensions</code>{' '}
            and click the reload button on the Brkthru Companion card
          </li>
        </ol>
      </section>
    </div>
  );
}
